<template>
  <v-overlay
    id="overlay"
    class="text-center"
    content-class="p-overlay-content-wrapper"
    absolute
  >
    <div class="p-overlay-content">
      <div class="mb-4">
        <p class="g-bold g-text-l">{{ text }}</p>
      </div>
      <v-progress-circular :size="50" color="light" indeterminate />
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'overlay',

  props: {
    text: {
      type: String,
      default: 'Loading your data...'
    }
  }
}
</script>

<style lang="scss" scoped>
#overlay {
  :global(.p-overlay-content-wrapper.v-overlay__content) {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;
  }

  .p-overlay-content {
    text-align: center;
  }
}
</style>
